/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'


export enum PrivilegeTypeEnum {
    座驾 = 1,
    头像框 = 2,
    声纹 = 3,
    房间皮肤 = 4,
    房间边框 = 5,
    贵族体验卡 = 6,
    VIP体验卡 = 7,
    开屏 = 8,
    盲盒 = 9,
    碎片 = 10,
    礼物 = 11,
    气泡 = 12,
}



export async function uploadImg(params) {
    const resp = await http.post('/live/misc/upload_img', {
        ...params,
        ...window.store.getState().env.deviceinfo,
    })
    return resp.data.data
}


export const get_chip_equip_list = createAsyncThunk(
  'store/get_chip_equip_list',
  async (p: any, store: any) => {
      const {h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/privilege/get_chip_equip_list',
      {
        ...p,
          mid: h_m,
          from: 'chip_equip',
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const create_chip_equip_splash = createAsyncThunk(
  'store/create_chip_equip_splash',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/create_chip_equip_splash',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const urge = createAsyncThunk(
  'store/urge',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/urge',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_equip_list_v2_balance = createAsyncThunk(
  'store/get_equip_list_v2_balance',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_equip_list_v2',
      {
          from: 'store',
          tab_name: 'car',
          offset: 0,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.my_coin || 0
  }
)

export const chip_equip_buy = createAsyncThunk(
  'store/chip_equip_buy',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/chip_equip_buy',
      p,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_store_product_preview = createAsyncThunk(
  'store/get_store_product_preview',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/get_store_product_preview',
      p,
      {store, xcErrorToast: true}
    )
    return resp.data.data?.ext_content || {}
  }
)

const initialState: {
  sliver: any
  base: {
      balance: number
  }
} = {
    sliver: {},
    base: {
        balance: 0,
    }
}

export const StoreSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_chip_equip_list.fulfilled, (state, action) => {
      const {personal_outfit = [], room_outfit = [], special_rights = []} = action.payload
      const personal = _map(personal_outfit, it => ({...it, logType: 'personal_decor'}))
      const room = _map(room_outfit, it => ({...it, logType: 'room_decor'}))
      const special = _map(special_rights, it => ({...it, logType: 'special'}))
      Object.assign(state, {
          sliver: {
            ...action.payload,
            all: [...personal, ...room, ...special]?.sort((a, b) => b.sort - a.sort),
            personal_outfit: personal?.sort((a, b) => b.sort - a.sort),
            room_outfit: room?.sort((a, b) => b.sort - a.sort),
            special_rights: special?.sort((a, b) => b.sort - a.sort),
        },
      })
    })
    builder.addCase(get_equip_list_v2_balance.fulfilled, (state, action) => {
      Object.assign(state.base, {
          balance: action.payload,
      })
    })
  },
})

export const useStore = () =>
  useSelector((store) => store.store)

export default StoreSlice.reducer
export const StoreActions = StoreSlice.actions
